import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignupFlowPage } from './signup-flow.page';

const routes: Routes = [
  {
    path: '',
    component: SignupFlowPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignupFlowPageRoutingModule {}
